import type { WebhookSubscription, WebhookSubscriptionBase } from "../../types";
import { createBaseService } from "./baseService";

const base = createBaseService<WebhookSubscription, WebhookSubscriptionBase>({
  tableName: "webhook_subscriptions",
  searchColumns: ["name", "url"],
  skipAuditFields: true,
});

export class WebhookSubscriptionService {
  static getAll = base.getAll;
  static get = base.get;
  static create = base.create;
  static update = base.update;
  static delete = base.delete;
}
